import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { forwardRef, Fragment } from 'react';
import { useDataTable } from './utils/useDataTable';
import { Table, TableHead, TableRow, TableCell, TableBody, TableHeadCell, TableCheckboxCell, TableExpandableSection, TableControllerCell } from '../Table';
import { CHECKBOX_CHECK_TYPE_DASH, CHECKBOX_CHECK_TYPE_TICK } from '../Checkbox';
import { renderExpandableSectionEmpty } from './utils/useDataTableExpandableSections';
import { getArrayOfScalarPropType, getScalarPropType } from '../../utils/propTypes';
import { DataTableRoot, DataTableFooter } from './style';
import { DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_BASE, DATA_TABLE_CLASS_PREFIX } from './constants';
import { useComponentTheme } from '../../utils/hooks';
import { useDataTableClassNames } from './utils/useDataTableClassNames';
import { PageNavigation } from '../PageNavigation';
export var DataTable = forwardRef(function DataTable(_ref, ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useDataTable = useDataTable(props),
      columns = _useDataTable.columns,
      data = _useDataTable.data,
      expandableSectionProps = _useDataTable.expandableSectionProps,
      rowSortOrder = _useDataTable.rowSortOrder,
      onHeadCellClick = _useDataTable.onHeadCellClick,
      enableRowSelection = _useDataTable.enableRowSelection,
      selectedRowIds = _useDataTable.selectedRowIds,
      onHeadSelectorCellClick = _useDataTable.onHeadSelectorCellClick,
      onDataSelectorCellClick = _useDataTable.onDataSelectorCellClick,
      someRowsSelected = _useDataTable.someRowsSelected,
      allRowsSelected = _useDataTable.allRowsSelected,
      enableExpandableSections = _useDataTable.enableExpandableSections,
      expandableSectionControllers = _useDataTable.expandableSectionControllers,
      renderExpandableSection = _useDataTable.renderExpandableSection,
      expandedSectionIds = _useDataTable.expandedSectionIds,
      onExpansionSectionControllerButtonClick = _useDataTable.onExpansionSectionControllerButtonClick,
      enablePageNavigation = _useDataTable.enablePageNavigation,
      pageNavigationProps = _useDataTable.pageNavigationProps,
      rootProps = _useDataTable.rootProps,
      tableProps = _useDataTable.tableProps,
      enableFooter = _useDataTable.enableFooter;

  var theme = useComponentTheme(DATA_TABLE_CLASS_PREFIX);
  var classNameComponents = useDataTableClassNames(DATA_TABLE_CLASS_PREFIX, className);
  return React.createElement(DataTableRoot, Object.assign({}, rootProps, {
    ref: ref,
    theme: theme,
    className: classNameComponents.Root
  }), React.createElement(Table, Object.assign({}, tableProps), React.createElement(TableHead, null, React.createElement(TableRow, null, enableRowSelection && React.createElement(TableCheckboxCell, {
    checked: someRowsSelected || allRowsSelected,
    checkedIcon: allRowsSelected ? CHECKBOX_CHECK_TYPE_TICK : CHECKBOX_CHECK_TYPE_DASH,
    isHeader: true,
    onClick: onHeadSelectorCellClick
  }), columns.map(function (column) {
    var key = column.key || column.id;
    var isController = enableExpandableSections && expandableSectionControllers[column.id];
    var paddingLeft = isController ? DATA_TABLE_EXPANDABLE_SECTION_OFFSET_LEFT_BASE : undefined;

    if (column.sortable) {
      return React.createElement(TableHeadCell, Object.assign({}, column.headCellProps, {
        key: key,
        columnId: column.id,
        "data-columnid": column.id,
        sortable: true,
        rowSortType: column.sortType,
        rowSortOrder: rowSortOrder,
        onClick: onHeadCellClick,
        paddingLeft: paddingLeft
      }), column.title);
    }

    return React.createElement(TableCell, Object.assign({}, column.cellProps, column.headCellProps, {
      key: key,
      "data-columnid": column.id,
      onClick: onHeadCellClick,
      paddingLeft: paddingLeft
    }), column.title);
  }))), React.createElement(TableBody, null, data.map(function (item) {
    var isSectionExpanded = enableExpandableSections && expandedSectionIds.includes(item.id);
    var isRowSelected = enableRowSelection && selectedRowIds.includes(item.id);
    var key = item.key || item.id;
    return React.createElement(Fragment, {
      key: key
    }, React.createElement(TableRow, {
      "data-rowid": item.id
    }, enableRowSelection && React.createElement(TableCheckboxCell, {
      checked: isRowSelected,
      onClick: onDataSelectorCellClick,
      "data-rowid": item.id
    }), columns.map(function (column) {
      var isController = enableExpandableSections && expandableSectionControllers[column.id];
      var CellTag = isController ? TableControllerCell : TableCell;

      var cellProps = _objectSpread(_objectSpread(_objectSpread({}, column.cellProps), column.dataCellProps), {}, {
        'data-rowid': item.id,
        'data-columnid': column.id
      });

      if (isController) {
        cellProps = _objectSpread(_objectSpread({}, cellProps), {}, {
          rowId: item.id,
          expanded: isSectionExpanded,
          onExpansionButtonClick: onExpansionSectionControllerButtonClick
        });
      }

      return React.createElement(CellTag, Object.assign({
        key: column.id
      }, cellProps), column.formatDataCellContent ? column.formatDataCellContent(item[column.id], item, column) : item[column.id]);
    })), enableExpandableSections && React.createElement(TableExpandableSection, Object.assign({}, expandableSectionProps, {
      expanded: isSectionExpanded,
      "data-expandablesectionid": item.id
    }), renderExpandableSection(item)));
  }))), enableFooter && React.createElement(DataTableFooter, {
    theme: theme,
    className: classNameComponents.Footer
  }, enablePageNavigation && React.createElement(PageNavigation, Object.assign({}, pageNavigationProps))));
});
DataTable.defaultProps = {
  columns: [],
  data: [],
  enableRowSelection: false,
  enableNeutralRowSorting: true,
  renderExpandableSection: renderExpandableSectionEmpty,
  enablePageNavigation: false
};